import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: null,
    status: null,
    currentShop: null,
    isLimitExceed: false,
    storeVariantsCount: null,
    storeMaxVariantsLimit: null,
    // Wizard status from getOnboardingUserStepsProgress. null until boot returns.
    onboardingStepsStatus: null,
  },
  reducers: {
    authenticateUser(state, action) {
      const data = action.payload.data;
      const shop = action.payload.shop || null;

      if (data && data.length !== 0 && data !== "undefined") {
        state.isLoggedIn = true;
        state.status = true;
        state.currentShop = shop;
      } else {
        state.isLoggedIn = false;
        state.status = true;
        state.currentShop = null;
      }
    },
    resetAuth(state) {
      state.isLoggedIn = null;
      state.status = null;
      state.currentShop = null;
      state.onboardingStepsStatus = null;
    },
    setOnboardingStepsStatus(state, action) {
      state.onboardingStepsStatus = action.payload;
    },
    setStoreLimitStatus(state, action) {
      const data = action.payload;
      state.isLimitExceed = data.status;
      state.storeVariantsCount = data.count;
      state.storeMaxVariantsLimit = data.maxVariantLimit ?? null;
    },
  },
});

export const authActions = authSlice.actions;

export default authSlice;
